import "./LisenceSelect.scss";
import { useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import { LicenseTypes } from "../types/LicenseTypes";
interface SelectProps {
  licenseType?: string;
  onClick: (text: string) => void;
  onClose: () => void;
}
const LisenceSelect: React.FC<SelectProps> = ({ licenseType, onClick, onClose }) => {
  const [active, setActive] = useState<string>(licenseType || "");
  const [code, setCode] = useState<string>("02001");
  const handleClick = (erpCode: string) => {
    setActive(erpCode);
    setCode(erpCode);
  };

  const buttonClick = () => {
    onClick(code);
  };
  return (
    <>
      <div
        style={{
          position: "fixed",
          width: "100%",
          bottom: "7%",
          zIndex: "9999",
          background: "#3c404a",
        }}
      >
        <div className="lisence-select-wrap">
          <div className="lisence-title-wrap">
            <div className="lisence-title">
              주 운전자 “면허종류”를 선택하세요.
            </div>
            <SvgIcon
              component={CloseOutlinedIcon}
              style={{
                fontSize: "3em",
                position: "absolute",
                left: "90%",
                color: "white",
              }}
              onClick={onClose}
            ></SvgIcon>
          </div>
          <div style={{ width: "100%", display: "ruby" }}>
            {LicenseTypes
              .filter((item) => item.isVisible)
              .map((item, index) => {
                return (
                  <div className={active === item.erpCode ? "lisenceCode active" : "lisenceCode"} 
                    onClick={() => handleClick(item.erpCode)} key={index}>
                    {item.description}
                  </div>
                );
              })
            }
          </div>
        </div>

        <div className="btn-wrap">
          <button
            style={{
              fontSize: "3em",
              border: "none",
              borderRadius: "0.3em",
              padding: "0.5em",
            }}
            onClick={buttonClick}
          >
            확인
          </button>
        </div>
      </div>
    </>
  );
};

export default LisenceSelect;
